import { render, staticRenderFns } from "./receptionPerformance.vue?vue&type=template&id=b303d660&scoped=true"
import script from "./receptionPerformance.vue?vue&type=script&lang=js"
export * from "./receptionPerformance.vue?vue&type=script&lang=js"
import style0 from "./receptionPerformance.vue?vue&type=style&index=0&id=b303d660&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b303d660",
  null
  
)

export default component.exports